<template>
  <div class="agreement-content">
    <div class="btn-box">
      <Button type="primary" @click="handleAddReceiptTemplete">添加电子收据</Button>
    </div>

    <div class="table-content">
      <Table
        border
        :columns="tableColumns"
        :data="tableData"
        :loading="loading"
      >
        <template slot="isEnable" slot-scope="{ row }">
          <span :class="row.isEnable===1?'normal-status-430':'stop-status-430'">{{ isEnableList[row.isEnable] }}</span>
        </template>
        <template slot="action" slot-scope="{ row }">
          <span class="click-btn-430" @click="handleEditReceiptTemplete(row)">修改</span>
        </template>
      </Table>
      <Page :total="total" show-elevator class="page-box" show-total :current="pageNum" :page-size="pageSize" @on-change="handlePage"></Page>
    </div>
  </div>
</template>
<script>
import courseCenterApi from '@/request/courseCenter/courseCenterApi.js';
export default {
  props: {
    schoolId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      total: 0,
      pageNum: 1,
      pageSize: 10,
      isEnableList: ['停用', '启用'],
      tableColumns: [
        {
          title: '序号',
          key: 'orderNumber',
          minWidth: 80,
          align: 'center'
        },
        {
          title: '年度学期',
          key: 'yearTermName',
          minWidth: 180,
          align: 'center'
        },
        {
          title: '协议模板状态',
          slot: 'isEnable',
          minWidth: 140,
          align: 'center'
        },
        {
          title: '创建时间',
          key: 'createTime',
          minWidth: 180,
          align: 'center'
        },
        {
          title: '更新时间',
          key: 'operateTime',
          minWidth: 180,
          align: 'center'
        },
        {
          title: '更新人',
          key: 'operatorName',
          minWidth: 140,
          align: 'center'
        },
        {
          title: '操作',
          slot: 'action',
          minWidth: 100,
          align: 'center',
          fixed: 'right'
        }
      ],
      tableData: [],
      loading: false
    };
  },
  mounted() {
    this.getReceiptTempleteList();
  },
  methods: {
    handleAddReceiptTemplete() {
      this.$router.push({
        name: `basicInfoCenter_company_schoolMage_addReceiptTemplete`,
        query: { schoolId: this.schoolId }
      });
    },
    handleEditReceiptTemplete(row) {
      this.$router.push({
        name: `basicInfoCenter_company_schoolMage_addReceiptTemplete`,
        query: { schoolId: this.schoolId, yearCode: row.yearCode, termCode: row.termCode, isEdit: 1 }
      });
    },
    handlePage(e) {
      this.pageNum = e;
      this.getReceiptTempleteList();
    },
    // 获取电子协议模板
    async getReceiptTempleteList() {
      const params = {
        orgId: this.schoolId,
        pageSize: this.pageSize,
        pageNum: this.pageNum
      };
      this.loading = true;
      const res = await courseCenterApi.getElectronicReceiptPageApi(params);
      this.loading = false;
      if (res.status === 200) {
        this.total = +res.message.total;
        this.tableData = res.message.list.map((item, index) => {
          item.orderNumber = (this.pageNum - 1) * this.pageSize + index + 1;
          return item;
        });
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.agreement-content{
  width: 100%;
  .btn-box{
    display: flex;
    justify-content: flex-end;
  }
  .table-content{
    margin-top: 24px;
  }
  .page-box{
    text-align: right;
    margin-top: 24px;
  }
}
</style>
